(() => {
  if (!window.location.pathname.includes('/products')) return;

  const SEZZLE = '.sezzle-shopify-info-button';
  const INSTALLMENTS = 5;
  let lastPrice = null, debounceTimer;

  document.head.insertAdjacentHTML('beforeend', `<style>${SEZZLE} ~ ${SEZZLE}{display:none!important}</style>`);

  const updateAmount = () => {
    const price = parseFloat(document.querySelector('.block-price__regular[data-abra-block="product"] .money')?.textContent.replace(/[^0-9.]/g, ''));
    if (isNaN(price) || price <= 0 || price === lastPrice) return;
    lastPrice = price;
    const installment = '$' + (price / INSTALLMENTS).toFixed(2);
    document.querySelectorAll('.sezzle-payment-amount').forEach(el => el.textContent = installment);
    document.querySelectorAll(SEZZLE).forEach(el => el.setAttribute('data-amount', price.toFixed(2)));
  };

  const removeDupes = () => {
    const all = [...document.querySelectorAll(SEZZLE)];
    all.slice(0, -1).forEach(el => el.remove());
  };

  document.querySelector('.block-price__container') &&
    new MutationObserver(() => { clearTimeout(debounceTimer); debounceTimer = setTimeout(updateAmount, 300); })
      .observe(document.querySelector('.block-price__container'), { childList: true, subtree: true });

  const dupeObserver = new MutationObserver((mutations) => {
    if (!mutations.some(({ addedNodes }) => [...addedNodes].some(n => n.nodeType === 1 && (n.classList?.contains('sezzle-shopify-info-button') || n.querySelector?.('.sezzle-shopify-info-button'))))) return;
    dupeObserver.disconnect();
    removeDupes();
    setTimeout(() => dupeObserver.observe(document.body, { childList: true, subtree: true }), 100);
  });
  dupeObserver.observe(document.body, { childList: true, subtree: true });

  const interval = setInterval(() => {
    if (!window.Abra?.render) return;
    clearInterval(interval);
    const orig = window.Abra.render.bind(window.Abra);
    window.Abra.render = function () { document.querySelectorAll(SEZZLE).forEach(el => el.remove()); return orig.apply(this, arguments); };
  }, 100);

  setTimeout(updateAmount, 1000);
})();
